import loadable from '@loadable/component';

export const AsyncPendingLoan = loadable(() => import('./PendingLoan'));
